import React, { useEffect, useState } from "react";
import HomeCarousel from "./Carousel";
import { Link } from "react-router-dom";
import EmptyContent from "./EmptyContent";

function Home({ event }) {
  const [featuredSpeakers, setFeaturedSpeakers] = useState(null);

  const who_attends = event?.who_should_attend
    ?.split("\n")
    .map((item) => item.trim())
    .filter(Boolean);

  const learnItems = event?.what_you_will_learn
    ?.split(/\r?\n/)
    .map((line) => {
      const [title, ...rest] = line.split("|");
      return {
        title: title?.trim(),
        description: rest.join("|")?.trim(),
      };
    })
    .filter((item) => item.title && item.description);

  useEffect(() => {
    if (!event.event_slug) return;
    
    fetch(`/api/events/${event.event_slug}/speaker/?featured=true`)
      .then((res) => res.json())
      .then(setFeaturedSpeakers);
  }, [event]);

  return (
    <div>
      <HomeCarousel events={event} />
      <div>
        {/* About section */}
        <section className="lg:grid lg:place-content-center bg-[#0166b1]">
          <div className="mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
            <div>
              <h1 className="text-4xl font-bold sm:text-5xl text-white">
                About the Workshop
              </h1>

              <p className="mt-4 text-base text-pretty sm:text-lg/relaxed text-gray-200">
                {event?.about_conference}
              </p>

              <div className="mt-4 flex justify-center gap-4 sm:mt-6">
                <a
                  className="inline-block rounded border border-indigo-600 bg-white px-5 py-3 font-medium hadow-sm transition-colors hover:bg-indigo-700"
                  href={`/events/${event.event_slug}/registration`}
                >
                  Register Now
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Who Should Attend */}
        <section className="py-12 bg-gray-800">
          <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              <div className="col-span-1">
                <h2 className="text-3xl/tight font-bold sm:text-4xl text-white">
                  Who Should Attend?
                </h2>

                <p className="mt-4 text-lg text-pretty text-gray-200">
                  This workshop is ideal for professionals and organizations
                  seeking to strengthen their innovation capability through
                  structured, standards-based approaches, including:
                </p>
              </div>

              <div className="space-y-6">
                <ul className="grid gap-4 sm:grid-cols-2">
                  {who_attends?.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-start gap-3 rounded-lg border p-4
                       shadow-sm transition-all duration-300
                       hover:-translate-y-1 hover:shadow-md
                       border-gray-700 bg-gray-900"
                    >
                      <span className="mt-1 inline-flex h-2 w-2 rounded-full bg-blue-600"></span>
                      <p className="text-gray-200">{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* What You'll Learn */}
        <section className="bg-gray-200 p-3">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-lg text-center">
              <h2 className="text-xl/tight font-bold text-gray-900 sm:text-4xl">
                What You'll Learn
              </h2>

              <p className="mt-4 text-lg text-pretty text-center text-gray-700 mb-6 leading-relaxed">
                Attending this workshop equips you with practical tools,
                strategic insights, and the connections you need to elevate your
                organization’s performance. Here’s what you can expect
              </p>
            </div>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              {learnItems?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 rounded-lg border p-6 border-gray-700"
                >
                  <div className="inline-flex rounded-lg bg-[#0033A01A] p-3 rounded-lg text-[#0033A0]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
                      ></path>
                    </svg>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {item.title}
                    </h3>

                    <p className="mt-2 text-pretty text-gray-700">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-4 md:mt-8 flex justify-center">
            <button className="inline-block rounded-sm bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition hover:bg-emerald-700 focus:ring-2 focus:ring-yellow-400 focus:outline-hidden">
              <Link to={`/events/${event.event_slug}/`}>Register Now</Link>
            </button>
          </div>
        </section>
        {/* Speakers Section */}
        <section className="bg-white lg:grid lg:place-content-center">
          <h2 className="mx-auto text-lg font-bold text-gray-900 sm:text-5xl text-center mt-7">
            Featured Speakers
          </h2>
          <p className="mx-auto text-center text-gray-900 mt-3">
            We’re honored to host a lineup of speakers who are shaping the
            future of standards, quality, and compliance. Get to know them
            below.
          </p>
          <div className="mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
            {featuredSpeakers && featuredSpeakers.length > 0 ? (
              <>
                <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
                  {featuredSpeakers.map((speaker, index) => (
                    <div key={index}>
                      <img
                        src={speaker.image}
                        alt={`${speaker.first_name} - ${speaker.last_name}`}
                        className="aspect-video rounded-lg object-cover object-top"
                      />

                      <div className="mt-4">
                        <div className="flex items-center justify-between gap-4">
                          <div>
                            <h3 className="text-lg/tight font-semibold text-gray-900">
                              {speaker.first_name} {speaker.last_name}
                            </h3>

                            <p className="mt-0.5 text-sm text-gray-700">
                              {speaker.position}, {speaker.organization}
                            </p>
                          </div>

                          <a
                            href={speaker.linkedIn}
                            target="_blank"
                            rel="noreferrer"
                            className="text-[#0072b1] transition-opacity hover:opacity-90"
                          >
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="size-7"
                            >
                              <path
                                d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                                clip-rule="evenodd"
                                fill-rule="evenodd"
                              ></path>
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div>
                  <button className="mt-6 flex justify-center mx-auto rounded-md bg-[#0166b1] px-5 py-3 font-medium text-white shadow-sm hover:bg-indigo-700">
                    <Link to="speakers">View All Speakers</Link>
                  </button>
                </div>
              </>
            ) : (
              <EmptyContent />
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
